// @ts-nocheck d35b9744
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_playbutton'],
      sections: [
        addPanel.sections.getSections().music.singleTrackPlayerSection,
      ],
    };
  },
};
